import Cookies from 'js-cookie'
export default function AccessToken() {
  let tenant_token = Cookies.get('tenantToken');
  if (tenant_token) {

    return {token: tenant_token};
  } else {
    return {token: ''};
  }
}



// WEBPACK FOOTER //
// ./src/services/auth-tenant.js